export var currencyType = [
  { value: -200, label: "All" },
  { value: 0, label: "ETH" },
  { value: 1, label: "Ripe Token" },
  { value: 2, label: "USDT" },  
  { value: 3, label: "USDC" },  
];